<template>
  <EIcon :id="id" />
</template>

<script>
import EIcon from './icon';

export default {
  name: 'EConditionIcon',
  components: {
    EIcon,
  },
  props: {
    code: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'outline',
      validator: (value) => ['outline', 'color'].includes(value),
    },
  },
  computed: {
    id() {
      return `weather-${this.type}-${this.code}`;
    },
  },
};
</script>
